import { APP_SLUG } from '@models/AppType'
import localForage from 'localforage'

export enum SurveyStorageKeys {
  CONSENT_DATA = 'consent',
  ANSWER_DATA = 'answer',
  PREDICTION_DATA = 'prediction',
  QUESTIONNAIRE_PHASE = 'questionnairePhase',
}

// To separate local storage from elections to booksellers and be able to have 2 separated apps.
const storageNamePrefix = 'datagotchi'
const storageName = `${storageNamePrefix}-${APP_SLUG ?? 'default'}`

export const surveyStorage = localForage.createInstance({
  name: storageName,
  storeName: 'survey',
})

export default {
  surveyStorage,
}
